"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WEBAPI_URL = exports.INTERNAL_WEBGATE_URL = void 0;
exports.INTERNAL_WEBGATE_URL = 'https://wgint.spotify.net';
exports.WEBAPI_URL = 'https://api.spotify.com';
//# sourceMappingURL=constants.js.map